import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/root/project/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {cleanupOutdatedCaches as workbox_precaching_cleanupOutdatedCaches} from '/root/project/node_modules/workbox-precaching/cleanupOutdatedCaches.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "assets/index-Cz9LXPUD.js",
    "revision": null
  },
  {
    "url": "assets/style.9_Y2sruE.css",
    "revision": null
  },
  {
    "url": "chunks/chunk.-kXBdAhV.js",
    "revision": "cbf891c20a037369e8abc63e85fa430b"
  },
  {
    "url": "chunks/chunk.8WQ9arHP.js",
    "revision": "d0d692c857c4667b174b89e6a66b1b52"
  },
  {
    "url": "chunks/chunk.FhKJGEEu.js",
    "revision": "39a37b1ca660414099272cd6f208a232"
  },
  {
    "url": "chunks/chunk.ijX8VbRw.js",
    "revision": "3a242ed8bb0d41f57ac698f5a35d5730"
  },
  {
    "url": "chunks/chunk.jLxxFlNK.js",
    "revision": "51c37a1e2659fdf2205616b31b1e42bc"
  },
  {
    "url": "chunks/chunk.jpKOP5D2.js",
    "revision": "92a048adca979433cc3683ef9bbcc69d"
  },
  {
    "url": "chunks/chunk.Kf2Ovkv1.js",
    "revision": "dbcd11aabd0146acc189a602ab327b79"
  },
  {
    "url": "chunks/chunk.l4YKX_3U.js",
    "revision": "0704adb8f2fd164edc6eb44b75aae03b"
  },
  {
    "url": "chunks/chunk.tS5mtgeA.js",
    "revision": "c918c9c5a75c62b288e5ffbacf70a96c"
  },
  {
    "url": "chunks/chunk.UYrF7xg1.js",
    "revision": "aeac06bd4a394288b93d795d3f2d68ea"
  },
  {
    "url": "chunks/chunk.y2E5DlLy.js",
    "revision": "04d222b6c836c56eb05b94c67441c898"
  },
  {
    "url": "manifest.webmanifest",
    "revision": "773f0ce04cc08ca28d351cb8df392322"
  }
], {});
workbox_precaching_cleanupOutdatedCaches();







